// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuIcon-module--wrapper--37pnA","open":"MenuIcon-module--open--l4cBY"};